var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messageBox"},[_c('avue-crud',{attrs:{"data":_vm.data,"option":_vm.option,"page":_vm.page},on:{"update:page":function($event){_vm.page=$event},"current-change":_vm.currentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }